import { useEffect, useState, useContext, useCallback } from "react";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import "./cart-item-btn.scss";
import colorStyle from "../../assets/kits/colors/colors.module.scss";
import { ShoppingCartIcon } from "../../components/kits/Icons/Icons";
import gv from "../../assets/kits/global-variables.module.scss";
import "overlayscrollbars/overlayscrollbars.css";
import CartItem from "./CartItem";
import { Prev } from "react-bootstrap/esm/PageItem";
import useAxios from "../../services/useAxios";
export default function CartItemBtn({
  isOpen2 = false,
  setHeight,
  height = 80,
  shopId = 6,
}) {
  const winWidth = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const [heightDiv, setHeightDiv] = useState(0);
  const [allPrice, setAllPrice] = useState(0);
  const [present, setPresent] = useState("");
  const [finishProgress, setFinishProgress] = useState(false);
  const [allDiv, setAllDiv] = useState([]);
  const {
    getItemsShop,
    changeShoppingCartItemCount,
    getItemCountPerShop,
    shoppingListItemsFinalState,
    updateShoppingList,
  } = useContext(ShoppingCartItemContext);

  const { execute: checkInventory } = useAxios("api/check_inventory");

  const [errorTxt, setErrorTxt] = useState("");
  // const [shoppingCartData, setShoppingCartData] = useState(
  //   getItemsShop(shopId)
  // );
  const shoppingCartData = getItemsShop(shopId);
  useEffect(() => {
    setFinishProgress(
      shoppingCartData?.supplier_info.min_order_amount - allPrice <= 0
    );

    setPresent(
      (allPrice / shoppingCartData?.supplier_info.min_order_amount) * 100
    );
    allDiv.length != 0 && setHeightDiv(allDiv[2].offsetHeight);
  }, [allDiv, isOpen, shoppingCartData.items.length, allPrice, errorTxt]);

  const check_inventory = () => {
    let form = new FormData();
    form.append("supplier_id", shopId);
    checkInventory(form).then((data) => {
      if (data.status != 1) {
        updateShoppingList();
        console.log("after update");
        let errorName = "";
        data.cartItems.map((item, index) => {
          errorName += `${item.product_title} ${
            index != data.cartItems.length - 1 ? " و " : ""
          }`;
        });
        setErrorTxt(
          `موجودی ${errorName} تمام شده و از سبد خرید شما حذف شده است`
        );
      }
    });
  };

  return (
    <div style={{ position: "fixed", zIndex: 15 }}>
      <button
        className="btn text-white d-flex mx-auto"
        onClick={() => {
          check_inventory();
          setIsOpen(true);
          setAllDiv(
            document
              .getElementById("drawer-container")
              .getElementsByTagName("div")
          );
        }}
      >
        <div
          className="cart-item-btn"
          style={{
            display: winWidth.width == undefined ? "none" : "block",
          }}
        >
          <div
            className={`${isOpen2 ? "" : "d-none "} d-flex ${
              finishProgress
                ? "justify-content-between align-items-center"
                : "flex-column justify-content-between"
            }   `}
            style={{
              borderRadius: "12px 12px 0px 0px",
              width: winWidth.width > 600 ? "600px" : "100%",
              height: "72px",

              background: colorStyle.orange_600,
              position: "fixed",
              bottom: "0",
              right:
                winWidth.width > 600
                  ? (winWidth.width - gv.max_width_var) / 2
                  : 0,
            }}
          >
            {finishProgress ? (
              <>
                <div className="text-white d-flex align-items-center mr-r-20 ">
                  <ShoppingCartIcon
                    style={{ marginBottom: "10px" }}
                    color="white"
                    className="text-font-size"
                  />
                  <span className="pd-x-12 txt-t2-m text-font-size">
                    مشاهده سبد خرید
                  </span>
                  <small
                    style={{ fontWeight: "100" }}
                    className="mr-t-2 desc-l  text-font-size"
                  >
                    {shoppingCartData.items
                      ? parseInt(shoppingCartData.items.length)
                      : 0}{" "}
                    کالا
                  </small>
                </div>
                <div className="text-white pd-x-24 txt-t2-m text-font-size">
                  <p lassName="txt-t2-m">
                    {allPrice && parseInt(allPrice).toLocaleString()} تومان
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="text-white d-flex align-items-certain mr-r-20 mr-t-20 text-font-size">
                  <p className="txt-t3-m ">حداقل خرید از این سوپرمارکت:</p>
                  <span className="desc-m mr-r-6 pd-t-2">
                    {parseInt(
                      shoppingCartData?.supplier_info.min_order_amount
                    ).toLocaleString()}{" "}
                    تومان
                  </span>
                </div>
                <div className="text-white pd-x-20 txt-t1-l text-font-size d-flex justify-content-between mr-b-16">
                  <div className=" mr-l-12 pd-t-8" style={{ width: "98%" }}>
                    {present != "" && (
                      <div class="progress" style={{ height: "6px" }}>
                        <div
                          class="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${present > 100 ? 100 : present}%`,
                          }}
                          aria-valuemin="0"
                          aria-valuemax={100}
                        ></div>
                      </div>
                    )}
                  </div>
                  <div
                    className="d-flex txt-t3-m "
                    style={{ width: "174px", whiteSpace: " nowrap" }}
                  >
                    {/* <p className="mr-l-6"></p> */} باقی مانده:{" "}
                    {(shoppingCartData?.supplier_info.min_order_amount -
                      allPrice <=
                    0
                      ? 0
                      : shoppingCartData?.supplier_info.min_order_amount -
                        allPrice
                    ).toLocaleString()}{" "}
                    تومان
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </button>
      {shoppingCartData && (
        <CartItem
          errorTxt={errorTxt}
          finishProgress={finishProgress}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          items={shoppingCartData.items ? shoppingCartData.items : []}
          changeShoppingCartItemCount={changeShoppingCartItemCount}
          shoppingListItemsFinalState={shoppingListItemsFinalState}
          shopId={shopId}
          setAllprice={setAllPrice}
          supplierName={shoppingCartData?.supplier_info?.title}
          heightDiv={heightDiv}
        />
      )}
    </div>
  );
}
